import { FieldErrors, UseFormRegister } from "react-hook-form";
import get from "lodash.get";

import { Field, FieldDescription, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form.tsx";

interface FormInputProps {
  name: string;
  label?: string;
  placeholder: string;
  type?: "text" | "textarea" | "email";
  variant?: "flat" | "bordered" | "faded" | "underlined";
  color?:
    | "default"
    | "primary"
    | "secondary"
    | "success"
    | "warning"
    | "danger";
  size?: "sm" | "md" | "lg";
  radius?: "none" | "sm" | "md" | "lg" | "full";
  isRequired?: boolean;
  disabled?: boolean;
  className?: string;
  description?: string;
  formFieldParams?: {
    register: UseFormRegister<any>;
    errors: FieldErrors<any>;
    loading: boolean;
    watch: (field: string) => any;
  };
  form?: any;
}

export const FormInput = ({
  name,
  className,
  label,
  variant = "bordered",
  color = "default",
  type = "text",
  radius = "sm",
  size = "sm",
  placeholder,
  description = "",
  isRequired = false,
  disabled = false,
  form = null,
  formFieldParams,
  ...rest
}: FormInputProps) => {
  const errors = [];
  const shortName = name?.split(".").pop();

  let value = "";

  if (formFieldParams) {
    value = formFieldParams.watch(name);
  }

  if (
    shortName &&
    formFieldParams &&
    typeof formFieldParams?.errors[shortName]?.message !== "undefined"
  ) {
    errors.push(formFieldParams?.errors[shortName]?.message);
  }
  if (formFieldParams) {
    const subError = get(formFieldParams?.errors, name);

    if (subError) {
      errors.push(subError.message);
    }
  }

  if (form !== null) {
    return (
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => (
          <FormItem className={className}>
            {label && (
              <FormLabel className="gap-1">
                {label}{" "}
                {isRequired && <span className="text-destructive">*</span>}
              </FormLabel>
            )}
            <FormControl>
              <Input
                placeholder={placeholder}
                {...field}
                disabled={disabled}
              />
            </FormControl>
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>
        )}
      />
    );
  }

  return (
    <Field className={className}>
      {label && <FieldLabel htmlFor={name}>{label}</FieldLabel>}
      <Input
        id={name}
        value={value ?? ""}
        required={!!isRequired}
        placeholder={placeholder}
        disabled={disabled}
        {...rest}
      />
      {description && <FieldDescription>{description}</FieldDescription>}
    </Field>
  );

  // return (
  //   <div className={className}>
  //     <div
  //       className={"text-xs leading-4 font-medium mb-2 text-zinc-400 uppercase"}
  //     >
  //       {label ?? ""}
  //     </div>
  //     <Input
  //       classNames={{
  //         inputWrapper: variant === "underlined" ? "border-b" : "border",
  //       }}
  //       value={value ?? ""}
  //       {...formFieldParams?.register(name)}
  //       color={color}
  //       description={description}
  //       errorMessage={errors[0]?.toString().replace(/<[^>]*>/g, "")}
  //       isInvalid={!!errors.length}
  //       isRequired={isRequired}
  //       placeholder={placeholder}
  //       radius={radius}
  //       size={size}
  //       type={type}
  //       variant={variant}
  //     />
  //   </div>
  // );
};
